const tpaRoutesDropdownLabels: Record<string, string> = {
  'wix.blog.sub_pages.post': 'LINK_PANEL_PAGE_BLOG_POST',
  'wix.blog.sub_pages.category': 'LINK_PANEL_PAGE_BLOG_POST_CATEGORY',
  'wix.bookings.sub_pages.service_page': 'LINK_PANEL_PAGE_BOOKINGS_SERVICE',
  'wix.groups.sub_pages.group': 'LINK_PANEL_PAGE_GROUPS_GROUP',
};

export const getTpaRoutesDropdownLabel = (subpage: string) =>
  tpaRoutesDropdownLabels[subpage] ?? 'LINK_PANEL_PAGE_ITEM_DEFAULT';
